module.exports = __webpack_public_path__ + "static/media/noImageXXL.d94fb8b0.jpg";